// extracted by mini-css-extract-plugin
module.exports = {"link":"_103a151b99--link--GoXdE"};